(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jb-shop-the-look"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jb-look-video')) {
    customElements.define('jb-look-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.control = this.querySelector('.jb-look-video__control');
        if (!this.video || !this.control) return;
        this.pauseIcon = this.control.querySelector('[data-pause-icon]');
        this.playIcon = this.control.querySelector('[data-play-icon]');
        this.control.addEventListener('click', this.togglePlayback);
        this.video.addEventListener('play', this.syncControl);
        this.video.addEventListener('pause', this.syncControl);
        this.syncControl();
      }

      disconnectedCallback() {
        if (!this.video || !this.control) return;
        this.control.removeEventListener('click', this.togglePlayback);
        this.video.removeEventListener('play', this.syncControl);
        this.video.removeEventListener('pause', this.syncControl);
      }

      togglePlayback = () => {
        if (this.video.paused) {
          this.video.play();
        } else {
          this.video.pause();
        }
      };

      syncControl = () => {
        const isPaused = this.video.paused;
        this.pauseIcon.hidden = isPaused;
        this.playIcon.hidden = !isPaused;
        this.control.setAttribute('aria-label', isPaused ? this.control.dataset.playLabel : this.control.dataset.pauseLabel);
      };
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jb-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jb-sticky-atc')) {
    customElements.define('jb-sticky-atc', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form[action*="/cart/add"]');
        this.variantInput = this.form?.querySelector('input[name="id"]');
        this.price = this.querySelector('[data-sticky-price]');
        this.mainButton = document.querySelector('[id^="ProductSubmitButton-template"]') || document.querySelector('.product__info-container [name="add"]');
        if (this.mainButton) {
          this.observer = new IntersectionObserver(([entry]) => {
            this.hidden = entry.isIntersecting;
          }, { threshold: 0.1 });
          this.observer.observe(this.mainButton);
        }
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => this.onVariantChange(event));
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        if (typeof this.unsubscribe === 'function') this.unsubscribe();
      }

      onVariantChange(event) {
        const variant = event?.data?.variant;
        if (!variant || !this.variantInput) return;
        this.variantInput.value = variant.id;
        this.variantInput.disabled = !variant.available;
        const button = this.form.querySelector('[name="add"]');
        if (button) button.disabled = !variant.available;
        const sectionId = event?.data?.sectionId;
        const updatedPrice = event?.data?.html?.getElementById(`price-${sectionId}`);
        if (updatedPrice && this.price) this.price.innerHTML = updatedPrice.innerHTML;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jb-video-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobileQuery = window.matchMedia('(max-width: 749px)');

    function syncSection(section) {
      const desktopVideo = section.querySelector('.jb-video-section__media--desktop video');
      const mobileVideo = section.querySelector('.jb-video-section__media--mobile video');
      const activeVideo = mobileQuery.matches ? mobileVideo : desktopVideo;
      const autoplay = section.querySelector('.jb-video-section__content')?.dataset.autoplay === 'true';

      [desktopVideo, mobileVideo].forEach((video) => {
        if (!video) return;
        if (video !== activeVideo || document.hidden || !autoplay) {
          video.pause();
          video.preload = 'none';
        } else {
          video.preload = 'metadata';
          video.play().catch(() => {});
        }
      });
    }

    function syncAll() {
      document.querySelectorAll('.jb-video-section').forEach(syncSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncAll, { once: true });
    } else {
      syncAll();
    }

    mobileQuery.addEventListener('change', syncAll);
    document.addEventListener('visibilitychange', syncAll);
    document.addEventListener('shopify:section:load', syncAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
